import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Idle } from 'idlejs';
import { AutoLogoutComponent } from './../../shared/components/auto-logout/auto-logout.component';
import { AnalyticsService } from './analytics.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  private idle?: Idle;
  private time: number = 60;
  isShowingLogout: boolean = false;

  constructor(
    private dialog: MatDialog,
    private userService: UserService,
    private analyticsService: AnalyticsService
  ) {
    this.userService.userProfile$.subscribe(user => {
      if (user) {
        this.time = user.autoLogoutTime;
        this.initializeIdle();
      } else {
        this.stopIdleChecking();
      }
    });
  }

  initializeIdle(time?: number) {
    time = time ?? this.time ?? 60;
    console.log('initializeIdle: ', time);
    try {
      if (this.idle) {
        this.stopIdleChecking();
      }

      this.idle = new Idle()
        .whenNotInteractive()
        .within(time)
        .do(() => {
          this.showLoggingOut();
        });
      /* .whenNot([{
        events: ['mousemove', 'keydown', 'scroll', 'touchstart'],
        target: window,
      }])
      .start(); */

      this.idle.start();

    } catch (error) {
      console.error('Failed to initialize idle checking: ', error);
    }
  }

  overrideIdleTime(time?: number) {
    console.log('overrideIdleTime: ', time);
    this.initializeIdle(time);
  }

  startIdleChecking() {
    console.log('startIdleChecking');
    //this.idle?.start();
    this.initializeIdle();
  }

  stopIdleChecking() {
    console.log('stopIdleChecking');
    this.idle?.stop();
    this.destroyIdle();
  }

  private destroyIdle() {
    this.idle = undefined;
  }

  private showLoggingOut() {
    this.isShowingLogout = true;
    console.log('showLoggingOut');
    this.analyticsService.trackSystemEvent('Auto Logout Triggered Dialog', 'AUTO_LOGOUT');
    let dialogRef = this.dialog.open(AutoLogoutComponent, { disableClose: true });

    const timeout = window.setTimeout(() => {
      console.log('auto logout timed out, do logout');
      dialogRef.close();
      this.logout();
      clearTimeout(timeout);
      this.stopIdleChecking();
      this.isShowingLogout = false;
    }, 30000);

    const sub = dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        console.log('auto logout accepted');
        sub.unsubscribe();
        this.logout();
      } else if (result === false) {
        console.log('auto logout cancelled');
        clearTimeout(timeout);
        sub.unsubscribe();
        this.initializeIdle();
      }
      this.isShowingLogout = false;
    });
  }

  private logout() {
    this.analyticsService.trackSystemEvent('Auto Logout Triggered Logout', 'AUTO_LOGOUT');
    // One navigation to a fresh /login — see `UserService.logoutAndRedirect`.
    this.userService.logoutAndRedirect();
  }
}
